$(function () {
    $('.tabs button').on('click', function (e) {
        if (!$(this).attr('data-tab')) {
            return
        }

        e.preventDefault()

        var $this = $(this)
        var tab = $this.attr('data-tab')
        var parent = $this.closest('.tabs-wrapper')

        if ($this.hasClass('mobile-tab-link')) {
            $this.toggleClass('active').siblings().removeClass('active')
            $this.next().toggle()
        } else {
            $this.addClass('active').siblings().removeClass('active')

            parent
                .find('.tab-content[data-tab=' + tab + ']')
                .addClass('active')
                .siblings('.tab-content')
                .removeClass('active')
        }
    })
})
